<template>
  <div class="information">
    <div class="form">
      <InputWrapper title="Название площадки">
        <BaseInput v-model="vuexValues.title" />
        <InvalidFeedback v-if="v$.vuexValues.$dirty && v$.vuexValues.title.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Стоимость (полчаса)">
        <BaseInput
          v-model="vuexValues.price"
          type="number"
          class="form__price-input"
        />
        <InvalidFeedback v-if="v$.vuexValues.$dirty && v$.vuexValues.price.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Телефон">
        <BaseInput
          v-mask="phoneMask"
          v-model="vuexValues.phone"
        />
        <InvalidFeedback v-if="v$.vuexValues.$dirty && v$.vuexValues.phone.required.$invalid">
          {{ errorText.required }}
        </InvalidFeedback>
        <InvalidFeedback v-if="v$.vuexValues.$dirty && v$.vuexValues.phone.isCorrectly.$invalid">
          {{ errorText.phone }}
        </InvalidFeedback>
      </InputWrapper>
    </div>

    <InputWrapper title="Дополнительно">
      <div class="radio-wrappers">
        <RadioWrapper class="radio-wrappers__item" title="Покрытие">
          <BaseRadio
            v-for="(item, index) of options.coating"
            :key="index"
            v-model="vuexValues.coating"
            :value="item.value"
            :label="item.text"
          />
        </RadioWrapper>
        <RadioWrapper class="radio-wrappers__item" title="Шипованные бутсы">
          <BaseRadio
            v-for="(item, index) of options.studdedCleats"
            :key="index"
            v-model="vuexValues.studdedCleats"
            :value="item.value"
            :label="item.text"
          />
        </RadioWrapper>
        <RadioWrapper class="radio-wrappers__item" title="Оплата переводом">
          <BaseRadio
            v-for="(item, index) of options.paymentTransfer"
            :key="index"
            v-model="vuexValues.paymentTransfer"
            :value="item.value"
            :label="item.text"
          />
        </RadioWrapper>
      </div>
    </InputWrapper>

    <InputWrapper title="Оснащение поля">
      <div class="radio-wrappers">
        <div
          v-for="(item, index) of fieldEquipment"
          :key="index"
        >
          <RadioWrapper
            class="radio-wrappers__item"
            :title="item.title"
          >
            <BaseRadio
              v-for="(option, index) of options.paid"
              :key="index"
              v-model="vuexValues[item.propName].radio"
              :value="option.value"
              :label="option.text"
            />

            <BaseInput
              v-if="vuexValues[item.propName].radio === 'paid'"
              v-model="vuexValues[item.propName].price"
              type="number"
              class="price-input"
              placeholder="Цена"
            />
          </RadioWrapper>
        </div>
      </div>
    </InputWrapper>

    <div class="panel">
      <BaseButton
        @click="onNext"
      >
        ДАЛЕЕ
      </BaseButton>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { phoneMask } from '@/constants'

import BaseButton from '@/components/Base/BaseButton'
import InputWrapper from '@/components/InputWrapper'
import RadioWrapper from '@/components/RadioWrapper'
import BaseInput from '@/components/Base/BaseInput'
import BaseRadio from '@/components/Base/BaseRadio'
import InvalidFeedback from '@/components/InvalidFeedback'

export default {
  name: 'AppInformation',
  components: {
    BaseButton,
    BaseRadio,
    RadioWrapper,
    BaseInput,
    InputWrapper,
    InvalidFeedback
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      phoneMask,
      options: {
        coating: [],
        studdedCleats: [
          { value: true, text: 'Можно' },
          { value: false, text: 'Нельзя' }
        ],
        paymentTransfer: [
          { value: true, text: 'Можно' },
          { value: false, text: 'Нельзя' }
        ],
        paid: [
          { value: false, text: 'Нет' },
          { value: true, text: 'Есть' },
          { value: 'paid', text: 'Есть платное' }
        ]
      },
      fieldEquipment: [
        {
          title: 'Мячи',
          propName: 'balls'
        },
        {
          title: 'Освещение',
          propName: 'lighting'
        },
        {
          title: 'Душевые',
          propName: 'showers'
        },
        {
          title: 'Раздевалки',
          propName: 'changingRooms'
        },
        {
          title: 'Манишки',
          propName: 'manishki'
        }
      ]
    }
  },
  computed: {
    vuexValues () {
      return this.$store.state.createField.infoStep
    },
    errorText () {
      return this.$store.state.errors.inputErrors
    }
  },
  async created () {
    await this.fetchCoating()
  },
  methods: {
    onNext () {
      if (this.v$.vuexValues.$invalid) {
        this.v$.vuexValues.$touch()
        return
      }

      this.$emit('next')
    },
    async fetchCoating () {
      try {
        const res = await this.$api.field.coating()
        const data = res.data?.option?.coating ?? []
        this.options.coating = data.map(item => ({
          value: item.value,
          text: item.text
        }))
      } catch (e) {
        console.log(e)
      }
    }
  },
  validations () {
    return {
      vuexValues: {
        title: {
          required
        },
        price: {
          required
        },
        phone: {
          required,
          isCorrectly: function (val) {
            return val.length === 18
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  .form {
    max-width: 500px;

    &__price-input {
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  .radio-wrappers {
    display: flex;
    flex-wrap: wrap;

    &__item {
      width: 200px;
      margin-right: 20px;
      margin-bottom: 20px;
      font-size: 14px;

      .price-input {
        background: #19191A;
        margin-top: 10px;
        width: 50%;
        height: 33px;
        font-size: 14px;

        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }

  .panel {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
